/** YYYY-MM-DD in local time — never use toISOString().split('T')[0] for calendar dates (UTC shift). */
export function toLocalDateKey(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Parse YYYY-MM-DD as local midnight. */
export function parseLocalDate(yyyyMmDd) {
  const [y, m, d] = String(yyyyMmDd || '').split('-').map(Number);
  if (!y || !m || !d) return new Date(yyyyMmDd);
  return new Date(y, m - 1, d);
}
